<template lang="pug">
include Dashboard.pug
</template>

<script>
import Api from "@/components/services/Api";
import PermissionsMixin from "@/mixins/Permissions";
import { mapState } from 'vuex';

export default {
  name: 'Dashboard',
  mixins: [PermissionsMixin],
  computed: mapState([
    "context", "token",
  ]),
  data() {
    // Data contained on the component
    return {
      editMenu: false,
      expired: false,
      link: null,
      user: null,
      plan: null,
      calculatedLink: null,
      vcard: false,
      slug: null,
    }
  },
  async created() {
    const meResponse = await Api.me(this.token)
    const data = meResponse.data
    const vcardResponse = await Api.getVcard(data.slug)
    this.slug = data.slug
    const vcard = vcardResponse.data
    const allowed = vcard.allowed

    this.vcard = allowed

    this.user = data
    this.image = this.user.image
    this.link = this.user.renovation_link
    this.expired = this.user.expired
    this.plan = data.plan

    if (this.link) {
      const domain = `${window.location.protocol}//${window.location.host}`
      this.calculatedLink = this.link + `&callback=${domain}/registro-profesional/final/`
    }
  },
  methods: {
    toggleEditMenu() {
      this.editMenu = !this.editMenu;
    }
  }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";
@import "./../../variables_mexreps";
@import "Dashboard";
@import 'DashboardColreps';
@import 'DashboardMexreps';

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue